export default function createObserver(element, cb) {
  let observer;
  let options = {
    root: null,
    rootMargin: '0px',
    threshold: [0],
  };
  observer = new IntersectionObserver(cb, options);
  observer.observe(element);
  return observer;
}
